import { Button, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useRef } from "react";

const RecommendationModal = ({
  onClickValue,
  handleClose = () => {},
  setOpenModal,
  openModal,
  modalHeadText,
  modalBodyText,
}) => {
  const popupRef = useRef(null);
  const style = {
    position: "absolute",
    top: onClickValue == "hsaddress1_var" ? "6.7rem" : "10rem",
    left: onClickValue == "hsaddress1_var" ? "-12rem" : "16rem",
    transform: "translate(-50%, -50%)",
    width: 300,
    background: "rgba(255, 255, 255, 1)",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    border:
      onClickValue == "hsaddress1_var"
        ? "0.50px #C5C5C5 solid"
        : onClickValue == "IM_Action"
        ? "1px solid rgba(12, 116, 54, 1)"
        : onClickValue == "NM_Action"
        ? "1px solid #991F01"
        : "1px solid rgba(12, 116, 54, 1)",
    p: 2,
    zIndex: 1300,
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    };
    if (openModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openModal, setOpenModal]);

  return (
    <Box sx={style} ref={popupRef}>
      <Typography
        id="modal-modal-title"
        variant="h6"
        component="h2"
        sx={{
          fontWeight: "600",
          color:
            onClickValue == "hsaddress1_var"
              ? "#242424"
              : onClickValue == "NM_Action"
              ? "#991F01"
              : "rgba(12, 116, 54, 1)",
        }}
      >
        {modalHeadText}
      </Typography>
      <Typography
        id="modal-modal-description"
        sx={{ mt: 2, fontWeight: "500" }}
      >
        {modalBodyText}
      </Typography>
    </Box>
  );
};

export default RecommendationModal;
